import moment from "jalali-moment";
import {withRouter} from "next/router";
import React from "react";
import styled from "styled-components";

import {device} from "../../constants/media";
import t from "../../utils/locale";

const Container = styled.div`
  @media ${device.below.tablet} {
    max-width: 150px;
    width: 40%;
    margin: 0.5rem;
  }

  @media ${device.below.mobileS} {
    width: 80%;
    margin: 1.5rem auto;
    max-width: 1000px;
  }

  display: flex;
  flex-direction: column;
  width: 150px;
  margin: 1.5rem;
  text-align: center;
`;

const Photo = styled.img`
  &:hover {
    border-radius: 3%;
  }

  &:focus {
    border-radius: 1%;
  }

  border-radius: 50%;
  transition: border-radius 0.3s;
  width: 100%;
`;

const Title = styled.div`
  font-size: 0.75rem;
  font-weight: bold;
  margin-top: 0.5rem;
`;

const Subtitle = styled.div`
  font-size: 0.75rem;
  color: #444;
  margin-top: 5px;
`;

const Dates = styled.div`
  font-size: 0.75rem;
  color: #aaa;
  margin-top: 5px;
`;

class EmployeeItem extends React.Component {
  render() {
    const current_language = this.props.router.locale;
    const employee = this.props.employee;
    const sdate = moment(employee.starting_date, "YYYY-M-D");
    const ldate = moment(employee.leaving_date, "YYYY-M-D");

    return (
      <Container>
        <Photo src={employee.cover} />
        <Title>{employee.name}</Title>
        <Subtitle>{employee.role}</Subtitle>
        {(employee.leaving_date && (
          <Dates>
            {sdate.locale(current_language).format("YYYY") +
              "-" +
              ldate.locale(current_language).format("YYYY")}{" "}
          </Dates>
        )) || (
          <Dates>
            {t(current_language, "From ") + sdate.locale(current_language).format("YYYY")}
          </Dates>
        )}
      </Container>
    );
  }
}

export default withRouter(EmployeeItem);
